import { Box, IconButton, IconButtonProps, Modal, SxProps, ModalProps } from '@mui/material'

import { useStyles } from './styles'
import { icons } from '../../../utils/icons';

export type BaseModalProps = {open:boolean, children: JSX.Element | null, addClose?:boolean; close?:IconButtonProps;  sx?:SxProps; modalProps?: ModalProps}
const BaseModal = (props: BaseModalProps) => {
  const styles = useStyles(props.sx)
  return (
    <Modal open={props.open} {...props.modalProps}>
      <Box sx={styles.modal} className='custome-modal-container'>
        {!!props.addClose && <Box sx={styles.close}><IconButton {...props.close}>{icons('simple-close')}</IconButton></Box>}
        {props.children}
      </Box>
    </Modal>
  )
}

export default BaseModal
